'use strict';

angular.module('kerp-forms.forms').service(
  'lincolnshireCareAssessmentCalculator',

  [
    '$window',
    'sfSelect',
    'objectUtils',
    'calculationResultService',

    function (
      $window,
      sfSelect,
      objectUtils,
      calculationResultService
    ) {

      function saveCalcResults(careType, calcResults, model) {
        calculationResultService.saveCalcResults(careType, calcResults, model);

        var personGeneratedPensionData = objectUtils.getPropertyPath(calcResults, 'generated.person.statePensionBeforeAgeAddition');
        var partnerGeneratedPensionData = objectUtils.getPropertyPath(calcResults, 'generated.partner.statePensionBeforeAgeAddition');

        if (personGeneratedPensionData) {
          sfSelect('person.income.retirementPension', model, personGeneratedPensionData.amount);
          sfSelect('person.income.retirementPensionPeriod', model, personGeneratedPensionData.period);
        }

        if (partnerGeneratedPensionData) {
          sfSelect('partner.income.retirementPension', model, partnerGeneratedPensionData.amount);
          sfSelect('partner.income.retirementPensionPeriod', model, partnerGeneratedPensionData.period);
        }
      }

      var constants = $window.kerpCfa.getConstants('LI_RFCA');

      this.recalculate = function (dirtyModel, cleanModel, isShortForm) {

        var recalculateCareTypes = Object.keys(constants.careTypes);
        var self = this;

        recalculateCareTypes.forEach(function (careType) {
          var calcResults = self.calculate(cleanModel, isShortForm, careType);

          saveCalcResults(careType, calcResults, dirtyModel);
          saveCalcResults(careType, calcResults, cleanModel);
        });
      };

      this.calculate = function (fields, isShortForm, careType) {
        return $window.kerpCfa.lincolnshire.calculator(fields, isShortForm, careType);
      };
    }
  ]
);
